
export const enLanguage=()=>{
    return {
        type:'en',
    }

};